var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.38516H16.6766C15.9586 7.38516 15.3766 6.80313 15.3766 6.08516V2.5M20 7.38516L15.3766 2.5M20 7.38516V18.3067C20 18.3725 20 18.437 20 18.5004C20 20.1573 18.6569 21.5 17 21.5H7C5.34315 21.5 4 20.1573 4 18.5004C4 18.437 4 18.3725 4 18.3067L4.04297 6.75771C4.04297 6.31986 4.04297 5.89746 4.04297 5.49992C4.04297 3.84306 5.38612 2.5 7.04297 2.5H15.3766M7.37643 12.1918H16.6373M7.37643 14.7228H11.6398M16.6373 17.785V17.785C16.2367 18.1545 15.5927 18.0306 15.3578 17.5388L15.3371 17.4954C15.1801 17.1668 14.7088 17.1774 14.5667 17.5127L14.2332 18.2995C14.1147 18.5791 13.7416 18.6327 13.5491 18.3978L13.2422 18.023C12.8548 17.55 12.1203 17.5866 11.7817 18.0957V18.0957M8.4194 5.77153H10.5242C11.0765 5.77153 11.5242 6.21925 11.5242 6.77153V8.69418C11.5242 9.24646 11.0765 9.69418 10.5242 9.69418H8.4194C7.86712 9.69418 7.4194 9.24646 7.4194 8.69418V6.77153C7.4194 6.21925 7.86712 5.77153 8.4194 5.77153Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.c9311bffbabc92357d338fac7f680ae2.svg";
export { ForwardRef as ReactComponent };